// @flow
import styles from './SVGDefs.scss';

type Props = { children: React.Node };

export function SVGDefs({ children }: Props): React.MixedElement {
  return (
    <svg aria-hidden="true" className={styles.root}>
      <defs>{children}</defs>
    </svg>
  );
}
